import * as Yup from 'yup';

const cameraSchema = Yup.object().shape({
  // Camera_ID: Yup.number().typeError('Camera ID must be a number'),
  Name: Yup.string().typeError('Camera name is required').required('Camera name is required'),
  Username: Yup.string(),
  Password: Yup.string(),
  IP_Address: Yup.string()
    .required('IP Address is required')
    .matches(
      // Regular expression for validating IP address
      /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/,
      'Invalid IP Address'
    ),
  Port_Number: Yup.number().typeError('Invalid Port Number').required('Port number is required'),
  Manufacturer: Yup.string(),
  Model: Yup.string(),
  url: Yup.string()
    .matches(
      // Regular expression for validating surveillance camera stream URL
      /^(rtsp|http|https):\/\/.*$/,
      'Invalid URL'
    )
    .required('URL is required'),
  url: Yup.string()
    .matches(
      // Regular expression for validating surveillance camera stream URL
      /^(rtsp|http|https):\/\/.*$/,
      'Invalid URL'
    ),
  Site: Yup.number().typeError('Site is required').required('Site is required'),

  Zone: Yup.number().typeError('Zone is required').required('Zone is required'),
  // status: Yup.boolean(),
  // fps: Yup.number().typeError('Invalid FPS').required('FPS is required'),
});

export const validateCamera = (cameraData) => {
  return cameraSchema.validate(cameraData, { abortEarly: false });
};

export default cameraSchema;
